import h from 'hyperscript';
import { WRAPPER_TYPES } from 'constants';
import { Adapters } from './media/video';
import { requiresFlash } from 'utilities/context';

export const ADAPTER_MAP = {
    [WRAPPER_TYPES.VIDEO_JS]: Adapters.VideoJSAdapter
};

export const PlayerFactory = {
    containerizePlayer: function (options) {
        if (options.player) {
            const adapter = ADAPTER_MAP[options.playerType],
                el = adapter.getPlayerEl(options.player);
            
            if (el && el.parentNode) {
                const parentNode = el.parentNode,
                    root = (
                        <div className="hapyak-app">
                            <div className="player_target">
                                { el }
                            </div>
                        </div>
                    );
                
                parentNode.appendChild(root);
                return root;
            }
        }

        throw 'player required to generate root';
    },
    create: function (options, eventBus) {
        let loadAdapter,
            { data = {} } = options;

        const playerType = data.project && data.project.playerType ? data.project.playerType : options.playerType;

        switch(playerType) {
            case WRAPPER_TYPES.VIDEO_JS:
                const flashAdapter = options.data.media.some(m => requiresFlash(m.url));
                loadAdapter = flashAdapter ? Adapters.VideoJSFlashAdapter : Adapters.VideoJSAdapter;
                break;
            case WRAPPER_TYPES.NO_MEDIA:
                loadAdapter = Adapters.NoMediaAdapter;
                break;
            default:
                loadAdapter = Adapters.VideoJSAdapter;
                break;
        }

        return loadAdapter().then(Adapter => new Adapter(options, eventBus));
    }
}